<div class="d-flex justify-content-between">
  <h2 mat-dialog-title>Upload Document</h2>
  <button color="primary" mat-icon-button [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>
</div>
@if (!uploadSuccess) {
<mat-dialog-content>
  <form [formGroup]="uploadDocumentForm" class="inputs-container">
    <mat-form-field appearance="outline">
      <mat-label>Document Name</mat-label>
      <input
        type="text"
        matInput
        formControlName="document_name"
        placeholder="Document Name"
      />
      @if (isFieldHasRequiredError('document_name')) {
      <mat-error>Document name is required</mat-error>
      }
    </mat-form-field>
    <app-tags-autocomplete
      [tags]="allAvailableTags"
      [defaultTags]="defaultTags"
      [config]="data.options.tagsAutocompleteOptions"
      (change)="onSelectedTagsChanged($event)"
    ></app-tags-autocomplete>
    @if (this.data.options.showExpiryDateColumn) {
    <mat-form-field appearance="outline">
      <mat-label>Expiry Date</mat-label>
      <input matInput [matDatepicker]="picker2" formControlName="expiry_date" />
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2 color="primary"></mat-datepicker>
    </mat-form-field>
    }
    <div class="mm-mt-3">
      @if (!uploadDocumentForm.get('document').value) {
      <div>
        <button
          mat-stroked-button
          color="primary"
          (click)="document.click()"
          class="upload-file-btn"
        >
          <div class="label">
            <span> Select File</span>
            <mat-icon>description</mat-icon>
          </div>
        </button>
        <div class="mm-text-center mm-mt-2"><b>Note:</b> Maximum file size 10MB</div>
        <input
          type="file"
          #document
          accept="application/pdf,image/*"
          style="display: none"
          id="file-upload"
          (change)="uploadFile($event)"
        />
      </div>
      } @else {
      <div class="uploaded-file">
        <span>{{ uploadDocumentForm.get('document').value?.name }}</span>
        <button mat-icon-button (click)="resetFile()">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
      } @if (isFieldHasRequiredError('document')) {
      <mat-error>Please select a file</mat-error>
      }
    </div>
    <!-- Unsupported Format Error Display -->
    @if (unsupportedFormatError) {
    <div class="format-error mm-mt-3">
      <mat-card appearance="outlined" class="format-error-card">
        <mat-card-header>
          <mat-icon class="error-icon" color="warn">warning</mat-icon>
          <mat-card-title class="error-title">Unsupported Document Format</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="error-message">{{ unsupportedFormatError }}</p>
          <div class="suggestions mm-mt-3">
            <p class="suggestions-title"><strong>Please try:</strong></p>
            <ul class="suggestions-list">
              <li>Converting the PDF to an image format (PNG or JPG)</li>
              <li>Using a different PDF file that is not encrypted or password-protected</li>
              <li>Ensuring the document is not corrupted</li>
              <li>Taking a clear photo of the document instead</li>
            </ul>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    }
    <!-- Verification Errors Display -->
    @if (verificationErrors.length > 0) {
    <div class="verification-errors mm-mt-3">
      <mat-card appearance="outlined" class="error-card">
        <mat-card-header>
          <mat-icon class="error-icon" color="warn">error</mat-icon>
          <mat-card-title class="error-title">Document Verification Failed</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="error-message">
            The uploaded document could not be verified. The following information does not
            match or was not found:
          </p>
          <ul class="error-list">
            @for (error of verificationErrors; track error) {
            <li class="error-item">
              <mat-icon class="item-icon">close</mat-icon>
              {{ error }}
            </li>
            }
          </ul>
          @if (verificationExpectedData) {
          <div class="expected-data mm-mt-3">
            <p class="expected-title"><strong>Expected Information:</strong></p>
            <div class="data-grid">
              @if (verificationExpectedData.firstname) {
              <div class="data-item">
                <span class="data-label">First Name:</span>
                <span
                  class="data-value"
                  [class.mismatch]="verificationMatches?.firstname === false"
                >
                  {{ verificationExpectedData.firstname }}
                  @if (verificationMatches?.firstname === false) {
                  <mat-icon class="mismatch-icon">highlight_off</mat-icon>
                  }
                </span>
              </div>
              } @if (verificationExpectedData.lastname) {
              <div class="data-item">
                <span class="data-label">Last Name:</span>
                <span
                  class="data-value"
                  [class.mismatch]="verificationMatches?.lastname === false"
                >
                  {{ verificationExpectedData.lastname }}
                  @if (verificationMatches?.lastname === false) {
                  <mat-icon class="mismatch-icon">highlight_off</mat-icon>
                  }
                </span>
              </div>
              } @if (verificationExpectedData.dob) {
              <div class="data-item">
                <span class="data-label">Date of Birth:</span>
                <span class="data-value" [class.mismatch]="verificationMatches?.dob === false">
                  {{ verificationExpectedData.dob }}
                  @if (verificationMatches?.dob === false) {
                  <mat-icon class="mismatch-icon">highlight_off</mat-icon>
                  }
                </span>
              </div>
              }
            </div>
          </div>
          }
          <p class="help-text mm-mt-3">
            Please ensure the document contains clear and legible information matching the
            expected data above.
          </p>
          <!-- Admin Override Section -->
          @if (isAdmin) {
          <div class="admin-override mm-mt-4">
            <mat-card appearance="outlined" class="override-card">
              <mat-card-content>
                <div class="override-content">
                  <mat-icon class="override-icon" color="accent"
                    >admin_panel_settings</mat-icon
                  >
                  <div class="override-text">
                    <p class="override-title"><strong>Admin Override Available</strong></p>
                    <p class="override-message">
                      As an admin, you can choose to upload this document anyway, bypassing the
                      verification check.
                    </p>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
    }
  </form>
</mat-dialog-content>
} @if (uploadSuccess) {
<mat-dialog-content class="mm-text-center mm-my-4">
  <div class="success-container">
    <h3 class="success-title">
      <mat-icon class="success-icon">check_circle</mat-icon>
      Document uploaded successfully
    </h3>
    <p class="success-message">You can upload another document if needed.</p>
  </div>
</mat-dialog-content>
} @if (!uploadSuccess) {
<mat-dialog-actions align="center" class="mm-mt-5 mm-mb-3">
  <!-- Show normal upload button when no verification errors or when override is not available -->
  @if (verificationErrors.length === 0) {
  <button
    mat-flat-button
    color="primary"
    [disabled]="uploadDocumentForm.invalid || loading"
    class="upload-btn"
    (click)="uploadDocument()"
  >
    @if (!loading) {
    <span>Upload</span>
    } @if (loading) {
    <span>Uploading, please wait...</span>
    }
  </button>
  }
  <!-- Show override button for admins when verification errors exist -->
  @if (verificationErrors.length > 0 && isAdmin) {
  <button
    mat-flat-button
    color="warn"
    [disabled]="uploadDocumentForm.invalid || loading"
    class="override-btn"
    (click)="overrideVerificationAndUpload()"
  >
    <mat-icon>shield</mat-icon>
    @if (!loading) {
    <span>Override & Upload Anyway</span>
    } @if (loading) {
    <span>Uploading, please wait...</span>
    }
  </button>
  }
  <!-- Show retry button for regular users when verification errors exist -->
  @if (verificationErrors.length > 0 && !isAdmin) {
  <button
    mat-stroked-button
    color="primary"
    [disabled]="uploadDocumentForm.invalid || loading"
    class="upload-btn"
    (click)="uploadDocument()"
  >
    @if (!loading) {
    <span>Try Upload Again</span>
    } @if (loading) {
    <span>Uploading, please wait...</span>
    }
  </button>
  }
</mat-dialog-actions>
} @if (uploadSuccess) {
<mat-dialog-actions align="center" class="mm-mt-5 mm-mb-3">
  <button mat-flat-button color="primary" (click)="resetFormForNextUpload()">
    Upload Another Document
  </button>
  <button mat-stroked-button color="warn" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>
}
